// FILE: src/components/student/IconDialogTitle.jsx
// The heading row of a notice dialog (WP-8): a tinted icon tile and the
// dialog's <h2> title (the theme renders DialogTitle as an h2). The icon is
// decorative; the words carry the meaning. Pass the same `id` the Dialog
// uses in aria-labelledby.
import { Box, DialogTitle } from "@mui/material";

const TINT = {
  primary: "zun.primaryTint",
  info: "zun.infoTint",
  warning: "zun.warningTint",
  error: "zun.errorTint"
};

export default function IconDialogTitle({ id, icon: Icon, tone = "primary", children }) {
  return (
    <DialogTitle id={id} sx={{ display: "flex", alignItems: "center", gap: 1.5, pb: 1.5 }}>
      {Icon && (
        <Box
          component="span"
          aria-hidden
          sx={{
            flexShrink: 0,
            width: 44,
            height: 44,
            borderRadius: 2.5,
            display: "grid",
            placeItems: "center",
            bgcolor: TINT[tone] || TINT.primary,
            color: `${tone}.main`
          }}
        >
          <Icon />
        </Box>
      )}
      <Box component="span" sx={{ minWidth: 0 }}>
        {children}
      </Box>
    </DialogTitle>
  );
}
